import React, {Component} from 'react';
import Wallpaper from '../common/ef-wallper';
import {connect} from "react-redux";
import {mapDispatchToProps, mapStateToProps} from "../common/redux-dispatch-to-props";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import PageContentWallpaper from "../common/ef-pageContent";
import eConfig from "../../config";
import DatePicker from "react-datepicker";
import LoadingProcessing from "../common/LoadingProcessing";
import moment from "moment";
import {Tab, Tabs} from "material-ui/Tabs";
import TableDataView from "../tables/TableDataView";


const sortData = (sortKey, data) => {
    const keyOne = sortKey;
    if (data === null) {
        return [];
    }
    data.sort((a, b) => (a[keyOne] > b[keyOne]) ? 1 : -1)
    return data;
}


class ConReconReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: null,
            isLoading: false,
            showEdit: false,
            startDate: "",
            endDate: "",
        }
    }

    componentDidMount = async () => {

    }
    handleInput = (e, key) => {
        let tmp = this.state;
        tmp[key] = e.target.value;
        this.setState(tmp);
    }
    getValue = (key) => {
        if (typeof this.state[key] !== "undefined") {
            return this.state[key]
        }
        return "";
    }
    handleChangeStartDate = (date) => {
        this.setState({
            startDate: date
        });
    }
    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date
        });
    }
    fetchReport = async () => {
        if (this.state.startDate === "" || this.state.endDate === "") {
            return alert("Please select your date range!")
        }
        let _this = this;
        let hub = {
            StartDate: this.convertDateFormat_YYYYMMDD(this.state.startDate),
            EndDate: this.convertDateFormat_YYYYMMDD(this.state.endDate),
        }

        const url = eConfig.serverBackendGlobal + "/backend-chela-recon/api/recon/report";

        this.setState({isLoading: true})

        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hub)
        })
            .then((response) => response.json())
            .then((response) => {
                if (typeof response.RESULT !== "undefined") {
                    let tmp = _this.state;
                    tmp.Data = response.RESULT;
                    tmp.isLoading = false;
                    _this.setState(tmp);
                    //TODO reinitialize state

                }
            }).catch((e) => {

        });
    }
    convertDateFormat_YYYYMMDD = (datesIn) => {
        let myDate = moment(datesIn).format("YYYY-MM-DD");
        return myDate;
    }

    boxList = (data, nameBox) => {

        let ls = [];
        for (let i in data) {
            let val = data[i];
            val = parseFloat(val);
            val = val.toFixed(0)
            ls.push({
                key: i,
                val: val
            })
        }

        return (
            <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-center active">
                    {nameBox}
                </li>
                {ls.map((row) => {
                    return (
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                            {row.key}
                            <span className="badge badge-primary badge-pill">{row.val}</span>
                        </li>
                    )
                })}
            </ul>
        )
    }
    renderSumaryChela = () => {
        if (this.state.Data === null) {
            return null
        }
        const data = this.state.Data;
        return this.boxList({
            "Total Record": data.TotalTransChela,
            "Total Cost": data.TotalCostChela,
            "Total Missing": data.TotalMissingCostChela
        }, "Sumary Chela");
    }
    renderSumaryTelkom = () => {
        if (this.state.Data === null) {
            return null
        }
        const data = this.state.Data;
        return this.boxList({
            "Total Record": data.TotalTransTelkom,
            "Total Cost": data.TotalCostTelkom,
            "Total Missing": data.TotalMissingCostTelkom
        }, "Sumary Telkom");
    }

    renderMissingTelkom = () => {
        let columns = [
            {id: 'ApiRef', label: 'Api Ref', minWidth: 170, dataType: "string"},
            {id: 'ParkCode', label: 'Product', minWidth: 170, dataType: "string"},
            {id: 'RechargeNumber', label: 'RechargeNumber.', minWidth: 170, dataType: "string"},
            {id: 'PriceActual', label: 'Price', minWidth: 170, dataType: "string"},
            {id: 'Category', label: 'Category', minWidth: 170, dataType: "string"},
        ];
        let ls = [];
        const attrs = this.state.Data.TriggerTelkom;
        for (let i in attrs) {
            const row = attrs[i];
            ls.push(row)
        }
        ls = sortData("TargetDate", ls);
        let data = {columns: columns, data: ls};
        return (
            <TableDataView
                {...data}
                tableTitle={"People Role Attribute"}
            />
        )

    }

    renderMissingChela = () => {

        let columns = [
            {id: 'ApiRef', label: 'Api Ref', minWidth: 170, dataType: "string"},
            {id: 'ProductType', label: 'Product', minWidth: 170, dataType: "string"},
            {id: 'AccountRef', label: 'Account.', minWidth: 170, dataType: "string"},
            {id: 'Dealer', label: 'Dealer', minWidth: 170, dataType: "string"},
            {id: 'ExtRef', label: 'Price', minWidth: 170, dataType: "string"},
            {id: 'InRef', label: 'RechargeNumber', minWidth: 170, dataType: "string"},
        ];
        let ls = [];
        const attrs = this.state.Data.TriggerChela;
        for (let i in attrs) {
            const row = attrs[i];
            ls.push(row)
        }
        ls = sortData("TransDate", ls);
        let data = {columns: columns, data: ls};
        return (
            <TableDataView
                {...data}
                tableTitle={"People Role Attribute"}
            />
        )
    }

    renderTabs = () => {
        if (this.state.Data === null) {
            return null
        }
        return (
            <Tabs>
                <Tab label="Missing Chela">
                    {this.renderMissingChela()}
                </Tab>
                <Tab label="Missing Telkom">
                    {this.renderMissingTelkom()}
                </Tab>


            </Tabs>
        )
    }


    render() {

        return (
            <Wallpaper {...this.props} hasHeader={true} hasFooter={true}>

                <PageContentWallpaper {...this.props} >
                    <MuiThemeProvider>
                        <h1>History Recon downloaded file from Telkom FTP</h1>

                        <div className="container">
                            <div className="row">
                                <div className="col col-lg-12">
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label htmlFor="inputState">Start Date</label>
                                            <DatePicker
                                                selected={this.state.startDate}
                                                onChange={this.handleChangeStartDate}
                                                className="form-control"
                                            />
                                        </div>

                                        <div className="form-group col-md-3">
                                            <label htmlFor="inputState">End Date</label>
                                            <DatePicker
                                                selected={this.state.endDate}
                                                onChange={this.handleChangeEndDate}
                                                className="form-control"
                                            />

                                        </div>


                                        <div className="form-group col-md-3">
                                            <label htmlFor="inputState">&nbsp;</label>
                                            <button
                                                className="form-control pull-right btn btn-default"
                                                onClick={() => this.fetchReport()}
                                            >Search
                                            </button>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className="row">
                                <div className="col col-lg-6">
                                    {this.renderSumaryChela()}
                                </div>
                                <div className="col col-lg-6">
                                    {this.renderSumaryTelkom()}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">

                                    {this.renderTabs()}

                                </div>
                            </div>

                        </div>


                        <LoadingProcessing open={this.state.isLoading}/>

                    </MuiThemeProvider>
                </PageContentWallpaper>

            </Wallpaper>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ConReconReport)
